export default __webpack_public_path__ + "static/DSC_0047-49601b4ff251b87933fdafc339976d39.jpg";